// Money formatting shared across the editor price card and the get-quote summary so both stay
// in lock-step. `dollars` rounds to whole dollars for headline prices; `dollarsCents` keeps cents
// for the monthly financing figure (e.g. "$69.63/mo").
export const dollars = (cents: number) => "$" + Math.round(cents / 100).toLocaleString("en-US");

export const dollarsCents = (cents: number) =>
  "$" + (cents / 100).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
